import { render, staticRenderFns } from "./desaffectation.vue?vue&type=template&id=6d96febc"
import script from "./desaffectation.vue?vue&type=script&lang=js"
export * from "./desaffectation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports